// extracted by mini-css-extract-plugin
export var imageHolder = "imageholder-module--imageHolder--87a76";
export var imageLoading = "imageholder-module--imageLoading--67ac3";